'use strict';

var GridCopySpecialEventButtonDirective = function GridCopySpecialEventButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-copy-special-event-button.html'),
    controller: 'GridCopySpecialEventButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
        $scope.onRowSelection(selectedRows, selectedRowIndexes);
      });
    }
  };
};
GridCopySpecialEventButtonDirective.$inject = [];
module.exports = GridCopySpecialEventButtonDirective;